module.exports = __webpack_public_path__ + "static/media/seo_icon.754fdf3e.svg";